module.exports = __webpack_public_path__ + "media/images/flags/4x3/spm-a16f493e706067c09354bdb4ef410d7d.svg";